import { render, staticRenderFns } from "./GridGallery.vue?vue&type=template&id=b60351f6"
import script from "./GridGallery.vue?vue&type=script&lang=js"
export * from "./GridGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports